module.exports = __webpack_public_path__ + "img/home-intro-bg.05827803.svg";